import script from "./LegoSetMinifigurer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegoSetMinifigurer.vue?vue&type=script&setup=true&lang=ts"

export default script